// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function toString(x) {
  if (x) {
    return "EXPIRED";
  } else {
    return "ACTIVE";
  }
}

function fromString(x) {
  switch (x) {
    case "ACTIVE" :
        return /* Active */0;
    case "EXPIRED" :
        return /* Expired */1;
    default:
      return ErrorUtils$Catalyst.raiseError("PpSubscriptionStatus.re", "invalid status for partner subscription", x);
  }
}

export {
  toString ,
  fromString ,
  
}
/* No side effect */
